// extracted by mini-css-extract-plugin
export default {"container":"home_container__hPfJk","header":"home_header__b1rpX","description":"home_description__bjPHr","link":"home_link__vHOSr"};